import React from 'react';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const PO_PAGE_SIZES = [25, 50, 100];

export const POPagination = ({ page, pages, pageSize, total, busy, stale, onRetry, onPage, onPageSize }) => {
  const first = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  return (
    <div className="flex flex-col gap-3 px-1 py-3 sm:flex-row sm:items-center sm:justify-between" data-testid="po-pagination">
      <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
        <span data-testid="po-pagination-range">{total === 0 ? 'No purchase orders' : `${first}–${last} of ${total}`}</span>
        {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" data-testid="po-pagination-busy" />}
        {stale && !busy && (
          <span className="text-xs text-amber-700 dark:text-amber-400" data-testid="po-refresh-failed">
            Couldn't refresh, showing the last loaded list.{' '}
            <button type="button" className="underline" onClick={onRetry} data-testid="po-refresh-retry">Retry</button>
          </span>
        )}
      </div>
      <div className="flex items-center justify-between gap-3 sm:justify-end">
        <div className="flex items-center gap-2 text-sm whitespace-nowrap">
          <span className="hidden text-muted-foreground sm:inline">Per page</span>
          <Select value={String(pageSize)} onValueChange={(v) => onPageSize(Number(v))}>
            <SelectTrigger className="h-8 w-[72px]" data-testid="po-page-size-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {PO_PAGE_SIZES.map((s) => <SelectItem key={s} value={String(s)} data-testid={`po-page-size-${s}`}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center gap-1">
          <Button variant="outline" size="sm" className="h-8" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="po-page-prev">
            <ChevronLeft className="h-4 w-4" /><span className="ml-1 hidden sm:inline">Previous</span>
          </Button>
          <span className="whitespace-nowrap px-2 text-sm tabular-nums" data-testid="po-page-indicator">Page {page} of {pages}</span>
          <Button variant="outline" size="sm" className="h-8" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid="po-page-next">
            <span className="mr-1 hidden sm:inline">Next</span><ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
